// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import {
  DefaultSectionCollapseButtonProps,
  PlasmicSectionCollapseButton,
} from "@/wab/client/plasmic/plasmic_kit_new_design_system_former_style_controls/PlasmicSectionCollapseButton";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import { Tooltip } from "antd";
import * as React from "react";

export interface SectionCollapseButtonProps
  extends DefaultSectionCollapseButtonProps {
  tooltip?: React.ReactNode | (() => React.ReactNode);
}

function SectionCollapseButton_(
  props: SectionCollapseButtonProps,
  ref: HTMLElementRefOf<"button">
) {
  const { tooltip, ...rest } = props;
  return (
    <PlasmicSectionCollapseButton
      root={{
        props: { ref },
        wrap: (root) => {
          if (tooltip) {
            return <Tooltip title={tooltip}>{root}</Tooltip>;
          } else {
            return root;
          }
        },
      }}
      {...rest}
    />
  );
}

const SectionCollapseButton = React.forwardRef(SectionCollapseButton_);
export default SectionCollapseButton;
